import { Injectable } from '@angular/core';

export interface IResponsiveService {
  isXs(): boolean;
  isSm(): boolean;
  isMd(): boolean;
  isLg(): boolean;

  isAtleastXs(): boolean;
  isAtleastSm(): boolean;
  isAtleastMd(): boolean;
  isAtleastLg(): boolean;

  getSize(): string;
}

@Injectable()
export class ResponsiveService implements IResponsiveService {
  xlExpr = '(min-width:1450px)';
  lgExpr = '(min-width:1200px)';
  mdExpr = '(min-width:992px)';
  smExpr = '(min-width:768px)';
  minimizeSideBarExpr = '(max-width:800px)';
  supportsMediaExpr = window.matchMedia && window.matchMedia('(min-width:1px)').matches;
  currentSize: string | null = null;
  currentTryMinimizeSidebar = false;

  getSize(): string {
    if (!this.supportsMediaExpr) return 'lg';

    if (window.matchMedia(this.xlExpr).matches) return 'xl';
    else if (window.matchMedia(this.lgExpr).matches) return 'lg';
    else if (window.matchMedia(this.mdExpr).matches) return 'md';
    else if (window.matchMedia(this.smExpr).matches) return 'sm';
    else return 'xs';
  }

  isXs(): boolean {
    return this.getSize() === 'xs';
  }

  isSm(): boolean {
    return this.getSize() === 'sm';
  }

  isMd(): boolean {
    return this.getSize() === 'md';
  }

  isLg(): boolean {
    return this.getSize() === 'lg';
  }

  isXl(): boolean {
    return this.getSize() === 'xl';
  }

  isAtleastXs(): boolean {
    return true;
  }

  isAtleastSm(): boolean {
    return !this.isXs();
  }

  isAtleastMd(): boolean {
    return !this.isXs() && !this.isSm();
  }

  isAtleastLg(): boolean {
    return this.isLg();
  }

  isAtleastXl(): boolean {
    return this.isXl();
  }

  //updateSize(): void {
  //    var newSize = getSize();
  //    if (this.currentSize !== newSize) {
  //        var notify = (this.currentSize !== null);
  //        if (notify)
  //            $rootScope.$broadcast(config.events.responsiveSizeChanged, currentSize, newSize);
  //    }

  //    var newTryMinimizeSidebar = window.matchMedia(this.minimizeSideBarExpr).matches;
  //    if (this.currentTryMinimizeSidebar !== newTryMinimizeSidebar) {
  //        this.currentTryMinimizeSidebar = newTryMinimizeSidebar;
  //        if (this.currentTryMinimizeSidebar) {
  //            var app = $('#app');
  //            if (!app.hasClass('nav-collapsed-min')) {
  //                app.addClass('nav-collapsed-min');
  //                $rootScope.$broadcast('nav:reset');
  //            }
  //        }
  //    }
  //}
}
